import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createSlots as _createSlots, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = { class: "absolute top-0 right-0 mt-4 mr-5" };
import componentI18n from '@/i18n/componentI18n';
const __default__ = {
    ...componentI18n('components.action_items')
};
import { computed, ref } from 'vue';
import { storeToRefs } from 'pinia';
import { useRetroStore } from '@/pinia_stores/retro';
import ActionItemFollowUp from '@/components/action_items/ActionItemFollowUp.vue';
import ActionItemOwnerAvatars from '@/components/action_items/ActionItemOwnerAvatars.vue';
import ActionItemOwnersText from '@/components/action_items/ActionItemOwnersText.vue';
import ActionItemTemplate from '@/components/action_items/ActionItemTemplate.vue';
import ModalDialog from '@/components/ModalDialog.vue';
import SvgIcon from '@/components/SvgIcon.vue';
export default /*#__PURE__*/ _defineComponent({
    ...__default__,
    __name: 'ActionItem',
    props: {
        item: { type: Object, required: true }
    },
    setup(__props) {
        const retroStore = useRetroStore();
        const { phase, isParticipant, isModerator, actionItemBeingEdited, userWritingActionItem } = storeToRefs(retroStore);
        const { startEditingActionItem, deleteActionItem } = retroStore;
        const showDeleteModal = ref(false);
        const canEdit = computed(() => {
            return ((phase.value === 'discussion' || phase.value === 'review') &&
                (isParticipant.value || isModerator.value) &&
                !actionItemBeingEdited.value &&
                !showDeleteModal.value &&
                !userWritingActionItem.value);
        });
        return (_ctx, _cache) => {
            const _component_user_entered_text = _resolveComponent("user-entered-text");
            const _directive_tooltip = _resolveDirective("tooltip");
            return (_openBlock(), _createElementBlock("div", null, [
                _createVNode(ActionItemTemplate, {
                    title: _ctx.$t('action_item'),
                    class: _normalizeClass([{ group: _unref(canEdit) }, "z-20"])
                }, _createSlots({
                    ownerAvatars: _withCtx(() => [
                        _createVNode(ActionItemOwnerAvatars, {
                            item: __props.item,
                            editable: _unref(canEdit)
                        }, null, 8, ["item", "editable"])
                    ]),
                    ownersText: _withCtx(() => [
                        _createVNode(ActionItemOwnersText, {
                            item: __props.item,
                            editable: _unref(canEdit)
                        }, null, 8, ["item", "editable"])
                    ]),
                    body: _withCtx(() => [
                        _createVNode(_component_user_entered_text, {
                            text: __props.item.description
                        }, null, 8, ["text"])
                    ]),
                    _: 2
                }, [
                    (_unref(phase) === 'setup')
                        ? {
                            name: "footer",
                            fn: _withCtx(() => [
                                _createVNode(ActionItemFollowUp, { item: __props.item }, null, 8, ["item"])
                            ])
                        }
                        : undefined,
                    (_unref(canEdit))
                        ? {
                            name: "buttons",
                            fn: _withCtx(() => [
                                _createElementVNode("div", _hoisted_1, [
                                    _withDirectives((_openBlock(), _createElementBlock("button", {
                                        class: "hidden mr-3 group-hover:inline",
                                        onClick: _cache[0] || (_cache[0] = ($event) => (_unref(startEditingActionItem)(__props.item.id)))
                                    }, [
                                        _createVNode(SvgIcon, {
                                            name: "pencil",
                                            class: "w-4 h-4 fill-gray-400 hover:fill-primary-400"
                                        })
                                    ])), [
                                        [_directive_tooltip, _ctx.$t('edit.tooltip')]
                                    ]),
                                    _withDirectives((_openBlock(), _createElementBlock("button", {
                                        class: "hidden group-hover:inline",
                                        onClick: _cache[1] || (_cache[1] = ($event) => (showDeleteModal.value = true))
                                    }, [
                                        _createVNode(SvgIcon, {
                                            name: "trash",
                                            class: "w-4 h-4 fill-gray-400 hover:fill-primary-400"
                                        })
                                    ])), [
                                        [_directive_tooltip, _ctx.$t('delete.tooltip')]
                                    ])
                                ])
                            ])
                        }
                        : undefined
                ]), 1032, ["title", "class"]),
                _createVNode(ModalDialog, {
                    centered: "",
                    "primary-actions": {
                        [_ctx.$t('delete.yes')]: () => _unref(deleteActionItem)(__props.item.id)
                    },
                    "secondary-actions": {
                        [_ctx.$t('delete.no')]: () => (showDeleteModal.value = false)
                    },
                    show: showDeleteModal.value
                }, {
                    heading: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('delete.question')), 1)
                    ]),
                    after: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('delete.before')), 1)
                    ]),
                    _: 1
                }, 8, ["primary-actions", "secondary-actions", "show"])
            ]));
        };
    }
});
